import {apiClient, utils} from './client';
import {AxiosResponse} from 'axios';
import {AvailabilityBoat, Yacht} from "@/models/Boat";
import {AvailabilityQuery} from "@/models/AvailabilityQuery";

const baseUrl = "/yacht"

export const get = (slug: string): Promise<AxiosResponse<Yacht>> => {
    return apiClient.get(`${baseUrl}/${slug}`);
};

export const searchAvailabilities = (searchParams: AvailabilityQuery): Promise<AxiosResponse<AvailabilityBoat[]>> => {

    const params = new URLSearchParams();
    for (const key in searchParams) {
        if (searchParams[key]) {

            if(searchParams[key] instanceof Date){
                params.append(key, utils.formatDate(searchParams[key]));
            }else{
                params.append(key, searchParams[key]);
            }
        }
    }
    return apiClient.get(`/availability?${params}`)
}